import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderStyle = styled(Box)`
  position: relative;
  color: #fff;
`;

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  padding: 0px 24px;
  display: flex;
  flex-direction: column;
  word-break: break-word;
  align-items: center;
  justify-content: space-evenly;

  img {
    max-height: 95px;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: auto;
    top: 50%;
    padding: 0px 24px;
    transform: translateY(-50%);
    justify-content: center;
    align-items: unset;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 0px 152px;

    h1 {
      font-size: 48px;
    }

    h3 {
      font-size: 43px;
      line-height: 43px;
    }
  }
`;

export const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const BannerStyle = styled(Box)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
